import React, { useEffect, useRef, useState } from 'react';
import { useRoomStore } from '../../../stores/room';
import { useUserStore } from '../../../stores/user';
import { UserStream } from '../../../widgets/user';
import VoxeetSDK from "@voxeet/voxeet-web-sdk";

import styles from './presentation.module.css';
import { upload } from '../../../libs/utils';

export function PresentationRoom(){
    const { participants, id } = useRoomStore();
    const { id: userId } = useUserStore();
    const [activeParticipants, setActiveParticipants] = useState(participants.filter(p => p.status === 'Connected' || p.status === 'Inactive'));
    const [image, setImage] = useState(null);
    const [video, setVideo] = useState(null);
    const [isScreenShare, setIsScreenShare] = useState(false);
    const screenShareRef = useRef(null);
    useEffect(() => {
        // setTimeout(() => {
        //     if(activeParticipants.length <= 11){
        //         setActiveParticipants([...activeParticipants, ...participants.filter(p => p.status === 'Connected' || p.status === 'Inactive')]);
        //     }
        // }, 2000)
    }, [activeParticipants]);
    useEffect(() => {
        VoxeetSDK.filePresentation.on('started', async (file) => {
            const url = await VoxeetSDK.filePresentation.image(0, file.id);
            setImage(url);
        });
        VoxeetSDK.videoPresentation.on('started', async (video) => {
            console.log('GOT VIDEO', video);
            setVideo(video.url);
        });
        VoxeetSDK.conference.on('streamAdded', (participant, stream) => {
            if(stream.type === 'ScreenShare'){
                navigator.attachMediaStream(screenShareRef.current, stream);
                setIsScreenShare(true);
            }
        });
    }, []);
    return <div className={`${styles.room}`}>
        <div className={styles.presentationpane}>
            {!image && !video && <div className={styles.emptymessagehost}>
                <button>Choose a file<input type="file" onChange={async e => {
                    const file = e.target.files[0];
                    if(file.type === 'video/mp4'){
                        const uploaded = await upload(file, `room/${id}`);
                        VoxeetSDK.videoPresentation.start(uploaded.secure_url);
                    }
                    else{
                        if(file){
                            VoxeetSDK.filePresentation.convert(file);
                            VoxeetSDK.filePresentation.on('converted', e => {
                                console.log('CONVERTED', e);
                                VoxeetSDK.filePresentation.start(e);
                            });
                        }
                    }
                }} /></button> to start presenting or <button onClick={() => {
                    VoxeetSDK.conference.startScreenShare();
                }}>Share Your Screen</button>
            </div>}
            {image && <img src={image} className={styles.image} />}
            {video && <video src={video} className={styles.video} controls />}
            {isScreenShare && <video className={styles.video} ref={screenShareRef} />}
        </div>
        <div className={styles.users}>
            {/* {activeParticipants.map(p => <UserStream key={p.id} user={p} />)} */}
        </div>
    </div>
}